import JPJContainer from "../../../components/pages/other/Jpj";

const JPJ = () => {
  return <JPJContainer />;
};

export default JPJ;
